<template lang="pug">
	.v-page-section-specialist.page-section-specialist(v-if="section" )
		template(v-if="section.items" )
			.page-section-specialist__row.flc(v-for="(row, index) in section.items" :key="index" )
				.page-section-specialist__header
					h3.page-section-specialist__row-title(v-if="row.title" ) {{ row.title }}
					.page-section-header__aside(v-if="row.links && row.links.length")
						.page-section-header__aside-links
							.page-section-header__aside-links-item(v-for="(link, linkIndex) in row.links" :key="linkIndex")
								a.page-section-header__aside-link.link(:href="link?.link") {{`${link?.text} ${link?.number}`}}
				.page-section-specialist__row-cards(v-if="row.items && row.items.length" )
					v-section-slider(:data-source="row" template="specialist" :options="options")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import breakpoints from "scripts/breakpoints.js";

export default {
	mixins: [sourceMixin],

	data() {
		return {
			section: null,
			options: {
				slidesPerView: 6,
				spaceBetween: 10,
				breakpoints: {
					[breakpoints['md-min']]: {
						slidesPerView: 6
					},
					[breakpoints['xs-min']]: {
						slidesPerView: 3
					},
					[breakpoints['4xs-min']]: {
						slidesPerView: 2
					}
				}
			}
		};
	},

	methods: {
		dataSet(data) {
			this.section = data;
		}
	}
};
</script>